import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import {
  clearStudyGroups,
  getStudygroupsInfinite,
} from "../../actions/studygroups";
import { noImagePlaceholder } from "../../constants/baseConst";

class StudyGroupsSuperhost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studygroup_ids: [],
      page: props.page || 1,
      query: {
        title: "",
        per_page: 6,
      },
    };
  }

  componentWillUnmount() {
    this.props.clearStudyGroups();
  }

  componentDidMount() {
    this.loadStudyGroups();
  }

  handleLoadMore = () => {
    this.setState(
      {
        page: this.state.page + 1,
      },
      this.loadStudyGroups
    );
  };

  loadStudyGroups = () =>
    this.props.loadStudygroups(this.state.query, this.state.page);

  render() {
    const { studygroups, page, total_pages } = this.props;

    return (
      <div style={{ width: "80%", margin: "auto" }}>
        {!studygroups.length && (
          <h5
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div>You are not currently a member of any MedMeetings.</div>
            <div>
              If you wish to join a MedMeeting, please visit{" "}
              <strong>"All Other MedMeetings".</strong>
            </div>
            <div>
              If you'd like to create a new MedMeeting, please email{" "}
              <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>
            </div>
          </h5>
        )}
        {!!studygroups.length && (
          <div>
            <div className="group-card-list">
              {studygroups.map(({ title, id, logo_url }) => (
                <div className="group-card" key={id}>
                  <img
                    className="group-card-image"
                    src={logo_url || noImagePlaceholder}
                  />
                  <div className="group-card-title">{title}</div>
                  <div className="group-card-button-group">
                    <Link to={`/groups/${id}/webinars/all`}>
                      <button className="group-card-button">Enter</button>
                    </Link>
                    <Link to={`/groups/${id}/edit`}>
                      <button className="group-card-button">Edit</button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            {page !== total_pages && (
              <a className="more_item" onClick={this.handleLoadMore}>
                Load more
              </a>
            )}
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <iframe
            src={
              "https://player.vimeo.com/video/1000795443?h=ffe4f47597&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            }
            width="700"
            height="500"
            webkitallowfullscreen
            mozallowfullscreen
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroups: state.studygroups.studygroups.values,
  query: state.studygroups.studygroups.query,
  page: state.studygroups.studygroups.page,
  total_pages: state.studygroups.studygroups.total_pages,
  count: state.studygroups.studygroups.count,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudygroups: (page, query) =>
    dispatch(getStudygroupsInfinite(page, query)),
  clearStudyGroups: () => dispatch(clearStudyGroups()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupsSuperhost);



// WEBPACK FOOTER //
// ./src/containers/StudyGroupsSuperhost/index.jsx